import RequestHandler from './request-handler'

class Exchanger {
    constructor(gateway, messageHandler, options, onConnectedCallback, onCloseCallback) {
        this._gateway = gateway;
        this._messageHandler = messageHandler;
        this._options = options;
        this._onConnectedCallback = onConnectedCallback;
        this._onCloseCallback = onCloseCallback;
        this._isConnected = false;
        this._sendedRequestHandlers = {};

        let exchanger = this;
    
        this._gateway.setCallbacks(
            function() { exchanger.onConnected(); }, 
            function() { exchanger.onClose(); }, 
            function(message) { exchanger.onMessage(message); }
        );
    }

    onConnected() {
        this._isConnected = true;

        if (this._onConnectedCallback) this._onConnectedCallback();
    }
    onClose() {
        if (this._onCloseCallback) this._onCloseCallback();
    
        this._isConnected = false;
        for (let [requestId, request] of Object.entries(this._sendedRequestHandlers)) {
            request.stopTimeout();
        }
        this._sendedRequestHandlers = {};
    }
    async onMessage(message) {
        var result = this._messageHandler.unpackMessage(message);

        if (!result.result) {
            if (result.errorResponse !== null)
                this.sendResponse(result.errorResponse);
        }
        else {
            if (result.isResponse)
                this.onReceiveResponse(result.data);
            else {
                var response = await this._messageHandler.handleRequest(result.data, this._options);
                if (response !== null && response !== undefined && this._isConnected)
                    this.sendResponse(response);
            }
        }
    }

    async sendRequest(request) {
        if (!this._isConnected) 
            return null;
        
        var requestHandler = new RequestHandler(request);
        this._sendedRequestHandlers[request.id] = requestHandler;
        return await this.processRequestHandler(requestHandler);
    }

    async processRequestHandler(requestHandler) {
        await this.sendMessageData(requestHandler.data);
    
        let response = await requestHandler.waitResponse();
        if (response === null) {
            //TODO: close connection?
            if (requestHandler.isMaxRetryCountReached()) {
                this._gateway.terminateConnection();
                return null;
            }

            requestHandler.increaseRetryCounter();
            
            if (!this._isConnected)
                return null;

            return await this.processRequestHandler(requestHandler);
        }
        
        return response;
    }

    sendResponse(response) {
        this.sendMessageData(response);
    }

    async sendMessageData(messageData) {
        await this._gateway.sendMessage(JSON.stringify(messageData));
    }

    onReceiveResponse(response) {
        if (this._sendedRequestHandlers.hasOwnProperty(response.req_id)) {
            let requestHandler = this._sendedRequestHandlers[response.req_id];
            requestHandler.onReceiveResponse(response);
            delete this._sendedRequestHandlers[response.req_id];
        }
    }
}

export default Exchanger;
